import React from 'react'
import { Layout } from 'antd'

const Footer: React.FC = () => {
  return <Layout.Footer className="admin-footer">{'Inkryptus ©2021'}</Layout.Footer>
}

export default Footer
